module.exports = __webpack_public_path__ + "img/Dashboard-Yoga@2x.d4c350bf.png";